import { appendScriptLoader, createAnalytics, type AnalyticsController } from '@falasta/analytics';
import { readonly, ref, type Ref } from 'vue';

import { analyticsMeasurementId } from '../config/runtime-config';

/**
 * Consenso ai cookie della copertina.
 *
 * Gemello di `apps/web/src/analytics/useCookieConsent.ts`: la logica sta tutta in
 * `@falasta/analytics` ed è verificata una volta sola, qui c'è il legame con Vue e
 * con `window`. I due file restano separati perché sono due applicativi con due
 * bundle: condividere un composable significherebbe una libreria Vue in mezzo,
 * cioè più impianto di quanto serva a quindici righe.
 */
let controller: AnalyticsController | null = null;

const asking: Ref<boolean> = ref(false);

function instance(): AnalyticsController {
  controller ??= createAnalytics({
    measurementId: analyticsMeasurementId,
    target: window,
    storage: window.localStorage,
    loadScript: appendScriptLoader(document),
  });

  return controller;
}

export interface CookieConsent {
  readonly asking: Readonly<Ref<boolean>>;
  accept(): void;
  refuse(): void;
  reopen(): void;
}

/** Da chiamare all'avvio: applica la scelta già data, o fa comparire il banner. */
export function startAnalytics(): void {
  const analytics = instance();
  analytics.start();
  asking.value = analytics.shouldAsk();
}

export function useCookieConsent(): CookieConsent {
  return {
    asking: readonly(asking),

    accept(): void {
      instance().grant();
      asking.value = false;
    },

    refuse(): void {
      instance().deny();
      asking.value = false;
    },

    reopen(): void {
      const analytics = instance();
      analytics.reset();
      asking.value = analytics.shouldAsk();
    },
  };
}
